import React, {Component} from 'react';





class NotReady extends Component {
	componentDidMount =() => {
		
	}
	render() {
		return (

			<div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                    <div className="container-fluid dashboard-content ">

                    	<div className="row">
                    		<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" style={{textAlign: 'center', paddingTop : "10em"}}>
                    			<h1 style={{color :"red"}}><i className="fas fa-wrench"></i></h1>
                    			<h3 className="mt-5" style={{color :"red"}}>준비 중인 페이지입니다.</h3>
                    		</div>
                    		
                    	</div>
                    </div>
                </div>
            </div>

		)
	}

}                    	


export default NotReady;